export default {
  Media: 'rgb(207, 223, 255)',
  Preprint: 'rgb(208, 240, 253)',
  Journal: 'rgb(194, 245, 233)',
  Report: 'rgb(209, 247, 196)',
  'Press Release': 'rgb(186, 30, 69)',
  'Posted Clinical Trial': 'rgb(209, 247, 196)',
  Conference: 'rgb(255, 234, 182)',
}
